import { render } from "./addEditAdminEventTemplate.vue?vue&type=template&id=0b0233f9"
import script from "./addEditAdminEventTemplate.vue?vue&type=script&lang=js"
export * from "./addEditAdminEventTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__